// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessionMain .MuiPaper-root.MuiDialog-paper {
  align-items: center !important;
  width: 400%;
  height: 388px;
}
.sessionExpireDescription {
  flex: initial !important;
}

.sessionButton {
  font-weight: 600 !important;
  background-color: #24b7aa !important;
  border-radius: 8px !important;
  text-transform: none !important;
  margin-right: 10px !important;
  font-size: 16px !important;
  width: 152px !important;
  height: 40px !important;
  font-family: Poppins !important;
  cursor: pointer !important;
  margin-top: 20px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/modals/sessionExpireModal.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,WAAW;EACX,aAAa;AACf;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;EAC1B,2BAA2B;AAC7B","sourcesContent":[".sessionMain .MuiPaper-root.MuiDialog-paper {\n  align-items: center !important;\n  width: 400%;\n  height: 388px;\n}\n.sessionExpireDescription {\n  flex: initial !important;\n}\n\n.sessionButton {\n  font-weight: 600 !important;\n  background-color: #24b7aa !important;\n  border-radius: 8px !important;\n  text-transform: none !important;\n  margin-right: 10px !important;\n  font-size: 16px !important;\n  width: 152px !important;\n  height: 40px !important;\n  font-family: Poppins !important;\n  cursor: pointer !important;\n  margin-top: 20px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
